import { HttpTimeoutError } from '@cian/peperrors/shared';
import { CircuitBreakerError } from '../../errors/circuitBreakerError.js';
import { getCircuitBreaker } from '../circuitBreaker/circuitBreakersStore.js';
export class CircuitBreakerHook {
    requestConfig;
    circuitBreaker;
    constructor(params) {
        this.requestConfig = params.requestConfig;
        this.circuitBreaker = getCircuitBreaker(params.context.requestHash, {
            failureTreshold: params.context.failureTreshold,
            samplingDuration: params.context.samplingDuration,
            minimumSamples: params.context.minimumSamples,
            maximumSamples: params.context.maximumSamples,
            openDuration: params.context.openDuration,
            maxTimeForHalfOpenRequest: params.context.maxTimeForHalfOpenRequest,
        });
    }
    onRequest() {
        if (!this.circuitBreaker.canRunTask()) {
            throw new CircuitBreakerError(this.requestConfig.url.origin + this.requestConfig.url.pathname);
        }
    }
    onResponse() {
        this.circuitBreaker.recordSuccess();
    }
    onError(err) {
        if (err instanceof HttpTimeoutError) {
            this.circuitBreaker.recordFailure();
        }
        else if (!(err instanceof CircuitBreakerError)) {
            this.circuitBreaker.recordSuccess();
        }
    }
}
//# sourceMappingURL=CircuitBreakerHook.js.map